<template>
  <div>
    <card :loading="loading" maxWidth="617px" class="card">

      <div class="card__title">Карточка клиента</div>
      <div class="card__subtitle">Пожалуйста, внимательно проверьте и заполните информацию о клиенте перед тем как
        переходить дальше
      </div>

      <el-form
          ref="cardForm"
          :model="userCard"
          :rules="rules"
          class="edit-form"
          label-position="top"
          @keyup.enter.native="submitCard"
      >

        <el-form-item prop="name" label="Имя">
          <el-input name="name" placeholder="Укажите имя" v-model="userCard.name"></el-input>
        </el-form-item>

        <el-form-item prop="birthday" label="Дата рождения">
          <el-date-picker
              v-model="userCard.birthday"
              type="date" format="dd.MM.yyyy"
              class="edit-form__select"
              placeholder="Выберите дату"
          />
        </el-form-item>

        <el-form-item prop="genderSelect" label="Пол">
          <el-select
              name="genderSelect"
              class="edit-form__select"
              v-model="userCard.genderSelect"
              placeholder="Укажите пол"
          >
            <el-option
                v-for="gender in genderList"
                :key="gender.id"
                :label="gender.title"
                :value="gender.id"
            ></el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div  v-loading="loadingQuestionnaire" class="container-list">
        <div class="container-list__title">Анкеты</div>
        <div v-for="item of diagnosticData"
             :key="item.id"
             class="container-list__item container-list-item">
          <div class="container-list-item__title">{{ item.title }}</div>
          <div class="container-list-item__value">{{ item.completed || 0 }}/{{ item.amount }}
          </div>
        </div>
      </div>

      <footer-buttons mt>
        <el-button type="primary" name="submitCard" :loading="loading" @click="submitCard">Далее</el-button>
      </footer-buttons>

    </card>

  </div>
</template>

<script>
import Vue from "vue"
import VueMask from "v-mask"
import {mapActions, mapGetters} from "vuex"
import Card from "../../../components/elements/Card.vue"
import FooterButtons from "@/components/dialog/FooterButtons"

Vue.use(VueMask)

export default {
  name: "session.card",
  data() {
    return {
      genderList: [],
      diagnosticData: [],
      loading: false,
      loadingQuestionnaire: true,
      rules: {
        surname: [
          {required: true, message: "Укажите фамилию", trigger: "blur"},
        ],
        name: [{required: true, message: "Укажите имя", trigger: "blur"}],
        genderSelect: [
          {required: true, message: "Укажите пол", trigger: "blur"},
        ],
        birthday: [{required: true, message: "Ошибка возраста", trigger: "blur"}],
      },
      error: null,
    };
  },
  components: {
    Card,
    FooterButtons
  },
  created() {
    if (!this.session) {
      this.$router.push({
        name: "session.create",
      })
    } else {
      this.loadLogic()
      this.getStageSession()
    }
  },
  computed: {
    ...mapGetters("session", {session: "session"}),
    userCard() {
      let userCard = this.session.user
      Vue.set(userCard, "genderSelect", userCard.gender.id)
      return userCard;
    },
    ages() {
      return Array.from(
          {
            length:
                process.env.VUE_APP_USER_AGE_MAX -
                process.env.VUE_APP_USER_AGE_MIN +
                1,
          },
          (value, key) => key + +process.env.VUE_APP_USER_AGE_MIN
      );
    },
  },
  methods: {
    ...mapActions({
      getStageSession: "session/CURRENT",
    }),
    loadLogic() {
      this.getQuestionnaire()
      this.loading = true

      this.$api.card
          .getGender()
          .then((response) => {
            this.genderList = response.data;
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            // this.pageLoading(false);
            this.loading = false
          })
    },
    getQuestionnaire() {
      this.loadingQuestionnaire = true

      this.$api.user
          .getQuestionnaire(this.session.user.id)
          .then((response) => {
            this.diagnosticData = response.data
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.loadingQuestionnaire = false
          })

    },
    goBack() {
      this.$router.push({
        name: "session",
      })
    },
    submitCard() {
      this.$refs.cardForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = Object.assign({}, this.userCard, {
            birthday: this.$root.dateBack(this.userCard.birthday),
            gender_id: this.userCard.genderSelect ? this.userCard.genderSelect : "",
            phone: this.userCard.phone ? this.userCard.phone.replace(/[^\d]/g, "") : "",
          });

          delete data.genderSelect;
          delete data.gender;
          this.$api.card
              .send(this.session.id, data)
              .then(() => {
                this.$notify.success({
                  title: "Успешно",
                  message: "Данные сохранены!",
                });
                this.$router.push({name: "session.questionnaire"})
              })
              .catch((response) => {
                this.$notify.error({
                  title: "Ошибка отправки данных 😕",
                  message: response.response.data.message,
                })
              })
              .finally(() => {
                this.loading = false
              })
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.user-card {
  max-width: 560px;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 38px;
    color: #333;
  }

  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btn {
    margin: 25px 0 0 0;
  }

  &__row {
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.edit-form {
  margin-top: 32px;

  &__select {
    width: 100%;
  }
}

.card {
  padding: 32px 48px;

  &__title {

    font-weight: 600;
    font-size: 24px;
    line-height: 26px;

    color: #111;
  }

  &__subtitle {
    margin-top: 12px;

    font-size: 15px;
    line-height: 20px;

    color: #8E8E93;
  }
}


.container-list {

  &__title {
    font-weight: bold;
    margin-top: 32px;
    font-size: 14px;
    line-height: 22px;

    color: #606266;
  }
}

.container-list-item {
  border-bottom: 1px solid #EAEAEA;
  padding: 13px 0;

  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 14px;
  line-height: 22px;
  color: #111;

  &__value {
    color: #676767;
  }
}

</style>
